import { getPageAllowedRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { AddMatchKeyButton, MatchKeysField } from "./MatchKeysField";
import { warehouseSettingsPageConfig } from "./warehouseSettingsPageConfig";
import { WriteOnlyNotice } from "./WriteOnlyNotice";
import {
  adaptWarehouseSettings,
  toWarehouseSettingsPayload,
  warehouseSettingsSaveConfirmation,
  warehouseSettingsValidators,
} from "./warehouseSettingsRecord";

export const warehouseSettingsRecordDefinition: RecordDefinition = {
  path: "/warehouse-settings",
  // The label the Warehouse API keeps this configuration's audits under.
  entityName: "WarehouseConfiguration",
  listRoute: "/settings",
  backTitle: "Back to settings",
  allowedRoles: getPageAllowedRoles("warehouse-settings"),
  config: warehouseSettingsPageConfig,
  // One configuration per installation, laid out here and nowhere else.
  authorable: false,
  readMethod: "GetWarehouseSettings",
  saveMethod: "SaveWarehouseSettings",
  recordAdapter: adaptWarehouseSettings,
  toSavePayload: toWarehouseSettingsPayload,
  saveConfirmation: warehouseSettingsSaveConfirmation,
  identity: {
    titleFields: [],
    fallbackTitle: "Warehouse Settings",
    newRecordTitle: "Warehouse Settings",
  },
  fieldComponents: {
    warehouseMatchKeys: MatchKeysField,
    warehouseAddMatchKey: AddMatchKeyButton,
    warehouseWriteOnlyNotice: WriteOnlyNotice,
  },
  fieldValidators: warehouseSettingsValidators,
};
